import type { Bitmap, WritableBitmap } from "./types.ts";
import { bitmapChannels } from "./types.ts";

function sharpen(
	{ width, height, data: originalData }: Bitmap,
	{ width: blurredWidth, height: blurredHeight, data: blurredData }: Bitmap,
	strength: number,
): WritableBitmap {
	if (width !== blurredWidth || height !== blurredHeight) {
		throw new Error("Original and blurred image dimensions don't match");
	}

	const sharpenedData = new Uint8ClampedArray(originalData.length);

	for (let i = 0; i < originalData.length; i += bitmapChannels) {
		const maskR = originalData[i] - blurredData[i];
		const maskG = originalData[i + 1] - blurredData[i + 1];
		const maskB = originalData[i + 2] - blurredData[i + 2];

		sharpenedData[i] = originalData[i] + maskR * strength;
		sharpenedData[i + 1] = originalData[i + 1] + maskG * strength;
		sharpenedData[i + 2] = originalData[i + 2] + maskB * strength;
		sharpenedData[i + 3] = 0xff;
	}
	return {
		width,
		height,
		data: new Uint8Array(sharpenedData),
	};
}

export default sharpen;
